import QuestionModel from "../QuestionModel";
import QuestionValue from "../QuestionValue";
import QuestionModule from "./QuestionModule";

export default class QuestionModuleSequence extends QuestionModule {
    constructor() {
        super();
    }

    create(data) {
        const question = super.create(data);
        question.step = data.step;

        if (data.type !== QuestionModel.TYPE_DIVISION) {
            this.generateOptions(question, data.values);
        } else {
            this.generateOptionsDivision(question, data.values);
        }

        return question;
    }

    generateOptions(question, total) {
        //for this one its easier to generate the series, then generate suitable options and add in our answer
        //first generate first value in series, and the series "step"
        let seriesStart, seriesStep;
        //just some nudges here of the start value according to type to make our series look a bit prettier
        if (question.type === QuestionModel.TYPE_ADDITION || question.type === QuestionModel.TYPE_MULTIPLICATION) {
            seriesStart = P3.math.randomInt(question.range.min, question.range.max);
            seriesStep = P3.math.randomInt(question.step ? question.step.min : question.range.min,
                question.step ? question.step.max : question.range.max);
        } else {
            if (question.type === QuestionModel.TYPE_SUBTRACTION) {
                seriesStart = P3.math.randomInt(question.range.min, question.range.max + 60);
                seriesStep = P3.math.randomInt(question.step ? question.step.min : question.range.min,
                    question.step ? question.step.max : question.range.max);
            }
            else if (question.type === QuestionModel.TYPE_DIVISION) {
                //now to handle division, we must ensure we have something divisible (not a prime), that divides by step
                //why not work this out by going the other way, by multiplying by step (we know we can reverse a multiply with a division)
                seriesStep = P3.math.randomInt(question.step ? question.step.min : question.range.min,
                    question.step ? question.step.max : question.range.max);
                seriesStart = P3.math.randomInt(question.range.min + 40, question.range.max + 100) * seriesStep;
            }
            else {
                //this is a times table sequence
                seriesStep = P3.math.randomInt(question.range.min, question.range.max);
                seriesStart = seriesStep * P3.math.randomInt(1, 3);
            }
        }

        //console.log(seriesStep, question.step);

        question.values.push(new QuestionValue(seriesStart));

        let lastValue = question.values[0];

        switch (question.type) {
            case QuestionModel.TYPE_MULTIPLICATION: {
                //minus one to account for series start already being in array
                for (let i = 0; i < total - 1; i++) {
                    question.values.push(new QuestionValue(lastValue.value * seriesStep));
                    lastValue = question.values[question.values.length - 1];
                }
                break;
            }
            case QuestionModel.TYPE_TIMES_TABLE:
            case QuestionModel.TYPE_ADDITION: {
                //minus one to account for series start already being in array
                for (let i = 0; i < total - 1; i++) {
                    question.values.push(new QuestionValue(lastValue.value + seriesStep));
                    lastValue = question.values[question.values.length - 1];
                }
                break;
            }
            case QuestionModel.TYPE_SUBTRACTION: {
                //minus one to account for series start already being in array
                for (let i = 0; i < total - 1; i++) {
                    question.values.push(new QuestionValue(lastValue.value - seriesStep));
                    lastValue = question.values[question.values.length - 1];
                }
                break;
            }
            case QuestionModel.TYPE_DIVISION: {
                //minus one to account for series start already being in array
                for (let i = 0; i < total - 1; i++) {
                    question.values.push(new QuestionValue(lastValue.value / seriesStep));
                    lastValue = question.values[question.values.length - 1];
                }
                break;
            }
            default : {
                console.log(question.type + " is not implemented for series");
                break;
            }
        }

        //set part of series we are looking for
        question.part = P3.math.randomInt(1, total - 1);

        const answer = question.values[question.part];

        //now generate suitable options
        let k = 100;
        let arr = [answer.value];
        while (k-- > 0 && question.options.length < 4) {
            const randValue = Math.round(parseInt(answer.value) + P3.math.randomInt(-question.values[question.values.length - 1].value * 0.1, question.values[question.values.length - 1].value * 0.1));
            if (arr.indexOf(randValue) === -1) {
                arr.push(randValue);
                question.options.push(new QuestionValue(randValue));
            }
        }

        question.options.push(new QuestionValue(answer.value));
        P3.utils.shuffleArray(question.options);
    }

    generateOptionsDivision(question, total) {
        //for this one its easier to generate the series, then generate suitable options and add in our answer
        //first generate first value in series, and the series "step"
        let seriesStart, seriesStep;
        //just some nudges here of the start value according to type to make our series look a bit prettier

        //now to handle division, we must ensure we have something divisible (not a prime), that divides by step
        //why not work this out by going the other way, by multiplying by step (we know we can reverse a multiply with a division)
        seriesStep = P3.math.randomInt(question.step ? question.step.min : question.range.min,
            question.step ? question.step.max : question.range.max);
        seriesStart = P3.math.randomInt(question.range.min + 40, question.range.max + 100) * seriesStep;

        question.values.push(new QuestionValue(seriesStart));

        let lastValue = question.values[0];

        //minus one to account for series start already being in array
        for (let i = 0; i < total - 1; i++) {
            question.values.push(new QuestionValue(lastValue.value * seriesStep));
            lastValue = question.values[question.values.length - 1];
        }

        //now reverse the array to make it a division sequence
        question.values = question.values.reverse();

        //set part of series we are looking for
        question.part = P3.math.randomInt(1, total - 1);

        const answer = question.values[question.part];

        //now generate suitable options
        let k = 100;
        let arr = [answer.value];
        while (k-- > 0 && question.options.length < 4) {
            const randValue = parseInt(answer) + P3.math.randomInt(1, question.values[question.values.length - 1]);
            if (arr.indexOf(randValue) === -1) {
                arr.push(randValue);
                question.options.push(new QuestionValue(randValue));
            }
        }

        question.options.push(new QuestionValue(answer.value));
        P3.utils.shuffleArray(question.options);
    }
}